var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 31.8812V53.9609L55.9998 47.1316V25.7324L41.125 31.8812Z",
    fill: "#ADBAD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5765L41.1252 31.8812L56 25.7324L26.8748 15.4277L12 21.5765Z",
    fill: "#DFEAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5762V43.6559L41.1252 53.9605V31.8808L12 21.5762Z",
    fill: "#CED9ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.1289 42.5133V25.5384C14.1289 24.8424 14.8221 24.3593 15.4751 24.6002L24.7549 28.024C25.1478 28.169 25.4088 28.5434 25.4088 28.9622V45.7767C25.4088 46.4661 24.7275 46.9487 24.077 46.72L14.7972 43.4567C14.3968 43.3159 14.1289 42.9377 14.1289 42.5133Z",
    fill: "#ADBAD1",
    stroke: "#DFEAFF",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.7461 46.7594V29.7845C26.7461 29.0885 27.4393 28.6054 28.0922 28.8463L37.3721 32.2701C37.765 32.4151 38.026 32.7895 38.026 33.2083V50.0227C38.026 50.7122 37.3447 51.1948 36.6942 50.9661L27.4144 47.7028C27.014 47.562 26.7461 47.1838 26.7461 46.7594Z",
    fill: "#ADBAD1",
    stroke: "#DFEAFF",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 39.4004L23.0411 41.7702",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 37.1992L23.0411 39.569",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 35L23.0411 37.3698",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 32.7988L23.0411 35.1686",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 30.5996L23.0411 32.9694",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5703 43.0625L35.5958 45.4323",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5703 40.8613L35.5958 43.2311",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5703 38.6621L35.5958 41.0319",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5703 36.4609L35.5958 38.8308",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5703 34.2617L35.5958 36.6315",
    stroke: "#37435A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3902 33.9336H51.7694C52.1309 33.9336 52.3729 34.3053 52.2267 34.6359L50.2024 39.2123H52.2474C52.6807 39.2123 52.9089 39.7259 52.6184 40.0475L47.3709 45.8569C47.0283 46.2362 46.4046 45.9178 46.5108 45.4179L47.246 41.956C47.312 41.645 47.0748 41.3522 46.7569 41.3522H45.0864C44.7401 41.3522 44.4986 41.0086 44.6159 40.6828L44.7637 40.2724C44.768 40.2546 44.7733 40.2368 44.7797 40.219L46.9197 34.2645C46.991 34.066 47.1793 33.9336 47.3902 33.9336Z",
    fill: "#37435A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEss);
export default __webpack_public_path__ + "static/media/ess.0ecc4bab5964974941f04e9e38c5efff.svg";
export { ForwardRef as ReactComponent };